import Repo from "../../Repository/Repo";

export const getBanksList = async() => {
  try {
    //   setLoading(true);
      let { data } = await Repo.banks({
        request: {
          method: "getBanksByCompany",
          data: {
            company_code: localStorage.getItem("companyCode"),
          },
        },
      });
    //   setLoading(false);
        // setRecords(data.response.data.banks);
        console.log('banks',data.response.data.banks)
        return data.response.data.banks
    } catch (err) {
      console.log("err:", err);
      setLoading(false);
    }
};